export const LEFT = 'left'
export const RIGHT = 'right'

export const ALL_DEPARTURE_SIDE_TYPES = [
  LEFT,
  RIGHT,
] as const

export type DepartureSideType = typeof ALL_DEPARTURE_SIDE_TYPES[number]
